import React from "react";
import styled from "styled-components";
import { useIsMobile } from "@utils/hooks";

interface MBAProps extends React.HTMLAttributes<HTMLDivElement> {
	applicationId?: string;
}
const allprogramsLeft = [
	{
		programLabel: "Specialised MBA",
		programs: [
			"MBA - Artificial intelligence",
			"MBA - Big Data Management",
			"MBA - E-Sports Management",
			"MBA - Engineering Management",
			"MBA - Finace Accounting",
			"MBA - Healthcare Management",
			"MBA - Human Resource Management",
			"MBA - Innovation & Entrepreneurship",
			"MBA - International Marketing",
			"MBA - IT Management",
			"MBA - Salesforce",
			"MBA - Supply Chain Management",
		],
	},
];
const allprogramsRight = [
	{
		programLabel: "General MBAs",
		programs: ["Master of Business Admistration", "One -year MBA"],
	},
];
export const MBA: React.FC<MBAProps> = ({ applicationId, ...htmlProps }) => {
	const isMobile = useIsMobile();
	return (
		<Container {...htmlProps}>
			{isMobile ? (
				<ContainerMobile>
					<>
						{allprogramsLeft.map((item) => {
							return (
								<>
									<ProramLabel>{item.programLabel}</ProramLabel>

									{item.programs.slice(0, 4).map((item) => {
										return <ProgramItem key={item}>{item}</ProgramItem>;
									})}
								</>
							);
						})}
						{/* {allprogramsRight.map((item) => {
							return (
								<>
									<ProramLabel>{item.programLabel}</ProramLabel>

									{item.programs.map((item) => {
										return <ProgramItem key={item}>{item}</ProgramItem>;
									})}
								</>
							);
						})} */}
					</>
				</ContainerMobile>
			) : (
				<>
					<Left>
						{allprogramsLeft.map((item) => {
							return (
								<>
									<ProramLabel>{item.programLabel}</ProramLabel>

									{item.programs.map((item) => {
										return <ProgramItem key={item}>{item}</ProgramItem>;
									})}
								</>
							);
						})}
					</Left>
					<Right>
						{allprogramsRight.map((item) => {
							return (
								<>
									<ProramLabel>{item.programLabel}</ProramLabel>

									{item.programs.map((item) => {
										return <ProgramItem key={item}>{item}</ProgramItem>;
									})}
								</>
							);
						})}
					</Right>
				</>
			)}
		</Container>
	);
};

const Container = styled.div`
	display: flex;
	flex-direction: row;
`;
const ContainerMobile = styled.div`
	display: flex;
	flex-direction: column;
`;

const Left = styled.div`
	display: flex;
	flex-direction: column;
`;
const Right = styled.div`
	display: flex;
	flex-direction: column;
	margin-left: 120px;
`;
const ProramLabel = styled.div`
	margin-top: 20px;
	font-weight: 600;
	font-size: 16px;
	line-height: 20px;
	color: ${({ theme }) => theme.colors.vividBlue};
`;

const ProgramItem = styled.div`
	font-weight: 400;
	font-size: 13px;
	line-height: 18px;
	margin-top: 10px;

	color: #000000;
`;
